import React, { useState, useEffect } from 'react';
import IntervalosSelect from '../Utils/IntervalosSelect';
import SelecionarCategoria from '../Utils/SelecionarCategoria';
import Markdown from '../Utils/Markdown';
import { Form, Button, Card, Alert, Col, InputGroup} from 'react-bootstrap';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { useProvider, Toast } from '../../context/MenuProvider';

const Template = () => {
    const { id, tipo } = useParams();
    const [mostrar, setMostrar] = useState(false);
    const [template, setTemplate] = useState({ativo:true});
    const [categoriaId, setCategoriaId] = useState(null);
    const [intervalos, setIntervalos] = useState([]);
    const [formErrors, setFormErrors] = useState([]);
    const { 
      setLinks, 
      setBtns,
      crud,
      salvarDados,
      buscarDadosPorId,
      setTitle,
      navigateTo,
      auth,
    } = useProvider();
    const { patch, post, get, del, loading } = crud || {};
    const formData = new FormData();
    
    
    const handleDelete = () => {
      Swal.fire({
        title: "Tem certeza em excluir?",
        text: "Esta ação é definitiva e todos os clientes não receberão mais mensagens com esse template, não poderá ser revertida.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sim, excluir!",
        cancelButtonText: "Cancelar"
      }).then(async(result) => {
        if (result.isConfirmed) {
          try{
            const response = await del(`/core/templates/${id}/`);
            navigateTo(-1);
            Toast.fire({
                icon: "success",
                title: 'Template excluída com sucesso'
            });
          }catch(err){
            validarErrosApi(err);
          }
        }
      });
    }

    // Configuração inicial dos botões e links
    useEffect(() => {
        setLinks([]);
        setBtns([
            ...(id ? [{ icon: 'bi-trash', onClick: handleDelete }] : []),
            { icon: 'bi-check-lg', onClick: handleSubmit }
        ]);
    
        return () => {
            setLinks([]);
            setBtns([]);
        };
    }, [setBtns, setLinks, id, categoriaId, intervalos, template]); // Dependências ajustadas
    // Carrega o templates ao editar
    useEffect(() => {
      if (id){
        carregarTemplate();
      }
      switch(tipo){
        case "cobranca":
          setTitle("Template de Cobranças");
          break;
        case "pos-venda":
          setTitle("Template de Pós Venda");
          break;
        case "reativar-cliente":
          setTitle("Template de Reativar Clientes");
          break;
        case "novidades":
          setTitle("Template de Novidades");
          break;
      }
    }, [id, tipo]);
    
    const dateToLocal =(data)=> {
      if (!data) return data;
      const dataObj = new Date(data);
      const valorFinal = dataObj.toLocaleString('sv-SE').replace(' ', 'T').slice(0, 16);
      return valorFinal;
    }
    
    const carregarTemplate = async () => {
        try {
            const response = await get(`/core/templates/${id}/`);
            if (response && response?.length) {
                const item = response[0];
                const dtAtivar = dateToLocal(item.data_ativar);
                const dtDesativar = dateToLocal(item.data_desativar);
                setTemplate({
                  ...item,
                  data_ativar:dtAtivar,
                  data_desativar:dtDesativar,
                });
                setCategoriaId(item?.categoria);
                setIntervalos(item.intervalos)
            }
        } catch (err) {
            validarErrosApi(err);
        }
    };

    const validarErrosApi = (err) => {
        //alert(JSON.stringify(err))
        const errorMessage = typeof err.response?.data === 'string' 
            ? 'Erro desconhecido ao salvar template.' 
            : err.response?.data?.detail;
        
        if(err.response?.data?.detail){
            Toast.fire({
                icon: "error",
                title: err.response?.data?.detail
            });
        }

        setFormErrors(prevErrors => ({
            ...prevErrors,
            apiError: errorMessage,
            nome_da_template: err.response?.data?.nome_da_template,
            descricao: err.response?.data?.descricao,
            marca: err.response?.data?.marca_id,
        }));
    };

    const handleSubmit = async (e) => {
        if(e) e.preventDefault();
        const errors = {};
        // if (!template?.nome_da_template) errors.nome_da_template = 'Por favor, informe o nome da template.';
        if (!categoriaId) errors.categoria = 'Por favor, informe o tipo da template.';
        
        if(!template?.horario) errors.horario = "Horário é obrigatório"
        // const hora = parseInt(template.horario?.split(':')[0], 10);
        // if (hora < 9 || hora > 21) {
        //     errors.horario = 'Horário permitido somente das 9h até 21:59';
        // }
        if (!intervalos?.length) errors.intervalos = 'Intervalo é obrigatório';
        if (Object.keys(errors).length > 0) {
            setFormErrors(errors);
            return;
        }
        
        setFormErrors({});

        
        // formData.append('intervalos', [1,2,3,4,5,6,7,8]);
        // formData.append('chave', template?.chave||``);
        // formData.append('nome', template?.nome||``);
        // formData.append('banco', template.banco || ``);
        template.categoria = categoriaId || null;
        template.intervalos = intervalos;
        //template.ativo=true;
        if(!template.data_ativar) template.data_ativar=null;
        if(!template.data_desativar) template.data_desativar=null;
        template.tipo=template.tipo ?? tipo;
        //template.pix_extra=false;
        //alert(JSON.stringify(template))
        
        const apiRequest = id ? patch : post;
        try {
            const response = await apiRequest(template, `/core/templates/${id?id+'/':''}`);
            if (response && response.length) {
                Toast.fire({
                    icon: "success",
                    title: `Salvo com sucesso`
                });
                navigateTo(-1);
            }
        } catch (err) {
            alert(JSON.stringify(err?.response))
            validarErrosApi(err);
        }
    };
    
    const carregarExemplo = () => {
      const mensagem = `Oi [nome], tudo bem? 😃
    
Passando aqui pra lembrar que o pagamento programado para [tempo_atraso] ainda está em aberto.
    
💰 *Valor:* [valor]
    
🛍 Pagamentos programados aqui⤵️
[link_pagamento_flex]
    
Agradeço pela atenção e pela confiança!
    
_(Mensagem automática)_
> Obs: Se o pagamento já foi realizado, por favor desconsidere esta mensagem.`;
    
      setTemplate(prev => ({
        ...prev,
        mensagem
      }));
    };

    useEffect(()=>{
      const carregarExemploChange = () => {
        const dicionario = {
            "empresa": auth?.empresa?.nome_da_loja || "Seu nome da Empresa",
            "ramo": "Comércio",
            "nome": "João",
            "nome_completo": "João da Silva",
            "valor": "R$ 12,45",
            "total_aberto": "R$ 100,00",
            "vencimento": "10/10/2025",
            "data_ultima_compra": "05/10/2025",
            "data_primeira_compra": "01/01/2023",
            "data_ultimo_pagamento": "08/10/2025",
            "dias_atraso": "3 dias",
            "tempo_ultima_compra": "05/10/2025 4 meses atrás",
            "tempo_atraso": "08/10/2025 10 dias atrás",
            "tempo_primeira_compra": "05/10/2025 1 ano e 2 meses atrás",
            "numero_de_compras": "10 compras",
            "parcela": "2/5",
            "link_pagamento": `https://${window.location.hostname}/p/cod/`,
            "link_pagamento_flex": `https://${window.location.hostname}/p/cod/flex/`
          }
          
        // JSON template com placeholders
        const mensagem = template?.mensagem || ``
        
        // Função para substituir placeholders no JSON
        function substituirPlaceholders(mensagem, dicionario) {
          //const jsonString = JSON.stringify(dicionario);
          const regex = /\[(\w+)\]/g;
          const resultString = mensagem?.replace(regex, (_, key) => dicionario[key] || `[${key}]`);
          return resultString;
        }
        
        const jsonFinal = substituirPlaceholders(mensagem, dicionario);
        setTemplate((prev)=>({
          ...prev,
          exemplo:jsonFinal
        }))
      }
      carregarExemploChange();
    }, [template?.mensagem, mostrar])
    

    return (
        <div className="">
              <>
                <>
                    <Form onSubmit={handleSubmit}>
                        {formErrors.apiError && <Alert variant="danger">{formErrors.apiError}</Alert>}
                        <Form.Group controlId="formTitulo" className="mt-3">
                          <div className="input-group">
                            <span className="input-group-text">Título</span>
                            <Form.Control
                              type="text"
                              value={template?.titulo || ``}
                              onChange={(e) => {
                                  setTemplate((prev)=>({
                                    ...prev,
                                    titulo:e.target.value
                                  }));
                              }}
                            >
                            </Form.Control>
                            {formErrors.titulo && <Alert variant="danger">{formErrors.titulo}</Alert>}
                          </div>
                        </Form.Group>
                        
                        <IntervalosSelect intervaloId={intervalos} setIntervaloId={setIntervalos} multiplos={true}/>
                        {formErrors.intervalos && <Alert variant="danger">{formErrors.intervalos}</Alert>}
                        
                        <SelecionarCategoria defaultText={` `} tipo={`tipo-cliente`} categoriaId={categoriaId} setCategoriaId={setCategoriaId} label="Tipo"/>
                        {formErrors.categoria && <Alert variant="danger">{formErrors.categoria}</Alert>}
                        
                        <Form.Group controlId="formHorario" className="mt-3">
                          <div className="input-group">
                            <span className="input-group-text">Horário</span>
                            <Form.Control
                              type="time"
                              value={template?.horario || ``}
                              onChange={(e) => {
                                  setTemplate((prev)=>({
                                    ...prev,
                                    horario:e.target.value
                                  }));
                              }}
                            >
                            </Form.Control>
                            {formErrors.horario && <Alert variant="danger">{formErrors.horario}</Alert>}
                          </div>
                        </Form.Group>
                          <Form.Group controlId="formIsAtivo" className="mt-3">
                            <Form.Check 
                              type="switch" 
                              label="Ativo"
                              disabled={(template?.data_desativar || template?.data_ativar)}
                              checked={template?.ativo}
                              onChange={(e) =>
                                setTemplate((prevItem) => ({
                                  ...prevItem,
                                  ativo: e.target.checked,
                                }))
                              }
                            />
                          </Form.Group>
                        <Form.Group controlId="formDatas" className="mt-3">
                          <InputGroup size="sm">
                            <span className="input-group-text"><i className="bx bx-toggle-right"></i></span>
                            <Form.Control
                              type="datetime-local"
                              value={template?.data_ativar || ``}
                              onChange={(e) => {
                                  setTemplate((prev)=>({
                                    ...prev,
                                    data_ativar:e.target.value
                                  }));
                              }}
                            >
                            </Form.Control>
                            <span className="input-group-text"><i className="bx bx-toggle-left"></i></span>
                            <Form.Control
                              type="datetime-local"
                              value={template?.data_desativar || ``}
                              onChange={(e) => {
                                  setTemplate((prev)=>({
                                    ...prev,
                                    data_desativar:e.target.value
                                  }));
                              }}
                            >
                            </Form.Control>
                          </InputGroup>
                          {(formErrors.data_desativar || formErrors.data_ativar) && <Alert variant="danger">{formErrors.data_ativar || formErrors.data_desativar}</Alert>}
                        </Form.Group>
                        
                        <Form.Group controlId="formMensagem" className="my-3">
                            <div className="small mb-1">
                              Use as chaves para valores dinâmicos. Olhe no <Button variant="outline-secondary" size="sm" onClick={()=>setMostrar(!mostrar)}> dicionário de chaves</Button> abaixo as variáveis disponíveis
                            </div>
                            <Form.Control 
                                as="textarea" 
                                rows={10}
                                value={template?.mensagem || ''} 
                                onChange={(e) => 
                                    setTemplate((prevTemplate) => ({
                                        ...prevTemplate,
                                        mensagem: e.target.value
                                    }))
                                }
                            />
                            {formErrors.mensagem && <Alert variant="danger">{formErrors.mensagem}</Alert>}
                        </Form.Group>
                        <Button variant="outline-secondary" size="sm" onClick={carregarExemplo}>Carregar Exemplo</Button>
                        {mostrar && (
                        <>
                          <Button variant="outline-secondary" className="ms-2" size="sm" onClick={()=>setMostrar(!mostrar)}>Ocultar dicionário</Button>
                          {template?.exemplo && (<>
                            <Card className="bg-light p-2 mt-2 rounded-2">
                              <Markdown texto={template?.exemplo} />
                            </Card>
                          </>)}
                          <div className="mt-3 p-2 fs-4 border-top">Dicionário de Variáveis</div>
                          <div className="small text-danger border-top">
                            <p>[empresa] = {auth?.empresa?.nome_da_loja || "Seu nome da Empresa"}</p>
                            <p>[ramo] = Comércio</p>
                            <p>[nome] = João</p>
                            <p>[nome_completo] = João da Silva</p>
                            <p>[valor] = R$ 12,45</p>
                            <p>[total_aberto] = R$ 100,00</p>
                            <p>[vencimento] = 10/10/2025</p>
                            <p>[data_ultima_compra] = 05/10/2025</p>
                            <p>[data_primeira_compra] = 01/01/2023</p>
                            <p>[data_ultimo_pagamento] = 08/10/2025</p>
                            <p>[dias_atraso] = 3 dias</p>
                            <p>[tempo_ultima_compra] = 5 meses atrás</p>
                            <p>[tempo_atraso] = 3 dias</p>
                            <p>[tempo_primeira_compra] = 100 dias</p>
                            <p>[numero_de_compras] = 10 compras</p>
                            <p>[parcela] = 2/5</p>
                            <p>[link_pagamento] = https://{window.location.hostname}/p/cod/</p>
                            <p>[link_pagamento_flex] = https://{window.location.hostname}/p/cod/flex/</p>
                          </div>
                          <div className="small">Obs: [link_pagamento_flex] é pagamento flexível, onde o cliente pode digitar o valor desejado para abater no valor total em aberto</div>
                        </>
                        )}
                        {!mostrar && (<>
                          <Button variant="outline-secondary" className="ms-2" size="sm" onClick={()=>setMostrar(!mostrar)}>Mostrar dicionário</Button>
                        </>)}
                        <Button variant="dark" type="submit" className="mt-4 w-100" disabled={loading}>
                            Salvar alterações
                        </Button>
                    </Form>
                </>
            </>
        </div>
    );
};


export default Template;